<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiChevronLeft } from "@mdi/js";
export default {
  name: "MdiChevronLeft",
  data() {
    return {
      svgPath: mdiChevronLeft,
    };
  },
};
</script>
